// extracted by mini-css-extract-plugin
var _1 = "src-components-JwtAuthLogicWrapper-_TextModalDialog__dialogText--ovixlMnvIGIgfCKjo6vi";
var _2 = "src-components-JwtAuthLogicWrapper-_TextModalDialog__modalRedirectDialog--HJnzGKCnTtP7bRpRqZoI";
export { _1 as "dialogText", _2 as "modalRedirectDialog" }
